import { Component, TemplateRef } from '@angular/core';
import { ApiService } from '../Services/api-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';

interface PointToRsConfig {
  ID: number;
  Points: number;
  Rupees: number;
  CreatedDate: string;
}

interface PointToRsResponse {
  ResponseData: any;
  ResponseMessage: string;
  ResponseCode: number;
}

@Component({
  selector: 'app-point-to-rs-configuration',
  templateUrl: './point-to-rs-configuration.component.html',
  styleUrls: ['./point-to-rs-configuration.component.css']
})
// export class PointToRsConfigurationComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {
//   }

// }


export class PointToRsConfigurationComponent {
  configList: PointToRsConfig[] = [];
  currentConfig: any = { Points: null, Rupees: null };
  modalRef: BsModalRef;
  isLoading: boolean = false;

  constructor(
    private apiService: ApiService,
    private toastr: ToastrService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {

    this.getPointToRsConfig();
  }

  getPointToRsConfig() {
    this.isLoading = true;
    this.apiService.GetApi(null, 'Scheme/GetAllPointToRsConfiguresEF').subscribe(
      (response: PointToRsResponse) => {
        if (response.ResponseCode === 200) {
          this.configList = response.ResponseData;
        } else {
          this.toastr.warning(response.ResponseMessage, 'Warning!', {
            timeOut: 2000
          });
        }
        this.isLoading = false;
      },
      (error) => {
        this.toastr.error('Failed to load configuration', 'Error!', {
          timeOut: 2000
        });
        this.isLoading = false;
      }
    );
  }

  openConfigModal(template: TemplateRef<any>, config?: PointToRsConfig) {
    if (config) {
      this.currentConfig = { ...config };
    } else {
      this.currentConfig = { Points: null, Rupees: null };
    }

    this.modalRef = this.modalService.show(template, {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md'
    });
  }

  onSubmitConfig(form: NgForm) {
    if (form.invalid) {
      this.toastr.warning('Please enter valid points and rupees values', 'Warning!', {
        timeOut: 2000
      });
      return;
    }

    if (!this.currentConfig.Points || !this.currentConfig.Rupees) {
      this.toastr.warning('Points and Rupees are required', 'Warning!', {
        timeOut: 2000
      });
      return;
    }

    this.isLoading = true;
    this.apiService.PostApi(this.currentConfig, 'Scheme/SetPointToRupees').subscribe(
      (response: PointToRsResponse) => {
        if (response.ResponseCode === 200) {
          this.toastr.success(response.ResponseMessage, 'Success!', {
            timeOut: 2000
          });
          this.getPointToRsConfig();
          this.modalRef.hide();
        } else {
          this.toastr.warning(response.ResponseMessage, 'Warning!', {
            timeOut: 2000
          });
        }
        this.isLoading = false;
      },
      (error) => {
        this.toastr.error('Failed to update configuration', 'Error!', {
          timeOut: 2000
        });
        this.isLoading = false;
      }
    );
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  decimalOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}